import { BaseRemoteService } from "@ofqual/portal-core/core/dataAccess";
import {
  Model,
  Opts,
  PagedResponse,
} from "@ofqual/portal-core/core/types";

export class ResourceTagsService extends BaseRemoteService {

  public async post(id: string, tagIds: number[], opts: Opts) {
    const model = {resourceType: "event-notifcations", tagIds} 
    const url = `${this.apiRoot}/resourcetags/${id}`;
    return await super.postRequest(url, model, opts);
  }

  public async get(id: string, opts: Opts) {
    // paged response is returned be fix the pageSize
    const url = `${this.apiRoot}/resourcetags/${id}?pageSize=9999`;
    const response = await super.getRequest<PagedResponse<Model>>(url, opts);
    return response.data && response.data.map((item: Model) => item.tagId);
  }
}
